import { TableFieldModel } from '@/model/TableList'
import { numberTimes, priceWithoutRate, totalPriceWithoutRate } from '@/utils/index'

export const TableField: TableFieldModel[] = [
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'no',
    fieldName: '编号',
    width: 150
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'name',
    fieldName: '名称'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'brand',
    fieldName: '品牌',
    width: 100
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'model',
    fieldName: '型号',
    width: 140
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'serial',
    fieldName: '序列号',
    width: 140
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'amount',
    fieldName: '数量',
    width: 80
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'unit',
    fieldName: '单位',
    width: 80
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'marketCost',
    fieldName: '市场成本',
    textAlign: 'right',
    isMoney: true,
    width: 100
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'outCost',
    fieldName: '外包成本',
    textAlign: 'right',
    isMoney: true,
    width: 100
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'orderFee2',
    fieldName: '单价(未税)',
    isMoney: true,
    textAlign: 'right',
    width: 120,
    convert: context => {
      const { rowData } = context
      const { orderFee } = rowData
      if (!orderFee) {
        return ''
      }
      const { orderTaxRate } = rowData
      // if (!orderTaxRate) {
      //   return orderFee
      // }
      return priceWithoutRate(orderFee, true, orderTaxRate)
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'orderFee',
    fieldName: '单价(含税)',
    isMoney: true,
    textAlign: 'right',
    width: 120
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'orderFee3',
    fieldName: '总价(未税)',
    isMoney: true,
    textAlign: 'right',
    width: 120,
    convert: context => {
      const { rowData } = context
      const { orderFee } = rowData
      if (!orderFee) {
        return ''
      }
      const { amount, orderTaxRate } = rowData
      // if (!orderTaxRate) {
      //   return orderFee
      // }
      return totalPriceWithoutRate(orderFee, amount, true, orderTaxRate)
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'orderFee4',
    fieldName: '总价(含税)',
    isMoney: true,
    textAlign: 'right',
    width: 120,
    convert: context => {
      const { rowData } = context
      const { orderFee } = rowData
      if (!orderFee) {
        return ''
      }
      const { amount } = rowData
      // if (!orderTaxRate) {
      //   return orderFee
      // }
      return numberTimes(orderFee, amount, true)
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'orderTaxRate',
    fieldName: '税率',
    formatType: 'percent',
    width: 110
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'type',
    fieldName: '业务类型',
    width: 100
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'businessClass',
    fieldName: '业务分类',
    width: 100
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'status',
    fieldName: '业务状态',
    width: 100
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'repairStatus',
    fieldName: '维修状态',
    width: 100
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'repairTimes',
    fieldName: '返修次数',
    width: 100
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'invoiceStatus',
    fieldName: '开票状态',
    width: 100
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'receivedStatus',
    fieldName: '收款状态',
    width: 100
  }
]
